import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

const propTypes = {
    cardHeading: PropTypes.string.isRequired,
    handleBack: PropTypes.func,
    iconType: PropTypes.string
};

export interface IHeaderUIProps {
    cardHeading?: string;
    handleBack?: Function;
    iconType?: string;
    handleHome?: Function;
    headerContext?: {
        title: string
    };
}

export interface IHeaderUIState {
}

export default class HeaderUI extends Component<IHeaderUIProps, IHeaderUIState> {

    static defaultProps = {
        cardHeading: 'Card Heading',
        iconType: 'default'
    };

    constructor(props) {
        super(props);
    }

    handleBack() {
        this.props.handleBack(this.props.headerContext);
    }

    handleHome() {
        this.props.handleHome();
    }

    getCardHeading() {
        const { cardHeading, headerContext } = this.props;

        return headerContext && headerContext.title || cardHeading;
    }

    render() {
        const { cardHeading, iconType, handleBack } = this.props;

        const leftIcon = <a className="dr-ui-btn-back" onClick={this.handleBack.bind(this)}>
                            <i className="fa fa-angle-left fa-2x" aria-hidden="true"></i>&nbsp;
                        </a>;
        const rightIcon = <a className="dr-ui-btn-home" onClick={this.handleHome.bind(this)}>
                            <i className="fa fa-home fa-2x" aria-hidden="true"></i>&nbsp;
                        </a>;
        return (
            <div className="dr-ui-header">
                <div className="nav">
                    { rightIcon }
                    { leftIcon }
                    <div className="dr-ui-center-outer">
                        <div className="header">{this.getCardHeading()}</div>
                    </div>
                </div>
            </div>
        );
    }

}

